import React, { useEffect, useState } from 'react';
import api from './api';
import toast from 'react-hot-toast';
import { FaSearch, FaDesktop, FaShieldAlt, FaUnlock, FaLock } from 'react-icons/fa';

const DevicesList = () => {
    const [devices, setDevices] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        fetchDevices();
    }, []);

    const fetchDevices = async (searchVal = '') => {
        try {
            const { data } = await api.get(`/devices?search=${searchVal}`);
            setDevices(data);
        } catch (err) {
            toast.error('Failed to load devices');
        }
    };

    const handleSearch = (e) => {
        setSearch(e.target.value);
        fetchDevices(e.target.value);
    };

    const toggleBypass = async (licenseId, currentBypass) => {
        try {
            await api.put(`/licenses/${licenseId}`, { bypass_global_blocks: !currentBypass });
            toast.success(`Protection ${!currentBypass ? 'Bypassed' : 'Restored'}`);
            fetchDevices(search);
        } catch (err) {
            toast.error('Failed to update protection');
        }
    };

    const userRole = JSON.parse(localStorage.getItem('user') || '{}').role;
    const isAdmin = userRole === 'admin' || userRole === 'super_admin';

    return (
        <div className="module">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                <h2 style={{ margin: 0 }}>Active Network Devices</h2>
                <div className="search-bar" style={{ position: 'relative' }}>
                    <FaSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#45a29e' }} />
                    <input 
                        placeholder="Search devices, owners or BE keys..." 
                        value={search}
                        onChange={handleSearch}
                        style={{ paddingLeft: '40px', width: '350px', margin: 0 }}
                    />
                </div>
            </div>

            <table>
                <thead>
                    <tr>
                        <th>Device & OS</th>
                        <th>Owner Info</th>
                        <th>Last Heartbeat</th>
                        <th>IP Address</th>
                        <th>Protection Status</th>
                        {isAdmin && <th>Action</th>}
                    </tr>
                </thead>
                <tbody>
                    {devices.length === 0 ? <tr><td colSpan={isAdmin ? "6" : "5"} style={{ textAlign: 'center', padding: '40px', color: '#888' }}>No devices found matching your criteria.</td></tr> : null}
                    {devices.map(d => (
                        <tr key={d.id}>
                            <td>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <FaDesktop style={{ color: d.status === 'online' ? '#66fcf1' : '#888' }} />
                                    <div>
                                        <div style={{ fontWeight: 'bold' }}>{d.device_name}</div>
                                        <small style={{ color: '#aaa' }}>{d.os_info}</small>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>{d.customer_name}</div>
                                <small style={{ color: '#45a29e' }}>{d.license_key}</small>
                            </td>
                            <td>
                                <div>{new Date(d.last_seen).toLocaleDateString()}</div>
                                <small style={{ color: '#888' }}>{new Date(d.last_seen).toLocaleTimeString()}</small>
                            </td>
                            <td style={{ fontFamily: 'monospace', fontSize: '0.9rem' }}>{d.ip_address}</td>
                             <td>
                                <div style={{ marginBottom: '5px' }}>
                                    <span className={`status ${d.status === 'online' ? 'active' : 'blocked'}`}>
                                        {d.status === 'online' ? 'Online' : 'Offline'}
                                    </span>
                                </div>
                                <div>
                                    {d.bypass_global_blocks ? (
                                        <span style={{ color: '#ff4d4d', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <FaUnlock /> Bypassed
                                        </span>
                                    ) : (
                                        <span style={{ color: '#00ff88', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <FaLock /> Active
                                        </span>
                                    )}
                                </div>
                            </td>
                            {isAdmin && (
                                <td>
                                    <button 
                                        onClick={() => toggleBypass(d.license_id, d.bypass_global_blocks)} 
                                        style={{ 
                                            width: 'auto', 
                                            padding: '8px 15px', 
                                            fontSize: '0.75rem', 
                                            background: d.bypass_global_blocks ? 'rgba(0, 255, 136, 0.1)' : 'rgba(255, 77, 77, 0.1)',
                                            border: `1px solid ${d.bypass_global_blocks ? '#00ff88' : '#ff4d4d'}`,
                                            color: d.bypass_global_blocks ? '#00ff88' : '#ff4d4d'
                                        }}
                                    >
                                        {d.bypass_global_blocks ? <><FaShieldAlt /> Enable Protection</> : <><FaUnlock /> Bypass All</>}
                                    </button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DevicesList;
